








import axios from 'axios';
import { AttachmentFile, getAttachmentDownloadUrl, getAttachmentMetadataUrl } from '@/utils/attachment';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoFile from '@/components/Organisms/CoFile/CoFile.vue';

export default {
    name: 'DownloadFile',
    components: {
        CoHeadline,
        CoFile,
    },
    props: {},
    computed: {
        metadataUrl(): string {
            return getAttachmentMetadataUrl(this.fileId);
        },
        downloadUrl(): string {
            const attachmentURL = this.file?.URL || this.file?.url || '';
            return getAttachmentDownloadUrl(attachmentURL);
        },
    },
    data() {
        return {
            fileId: this.$route?.params?.fileId || null,
            file: null as AttachmentFile | null,
            wasLoaded: false,
        };
    },
    async mounted() {
        if (!this.fileId || this.fileId.length < 1) {
            this.$router.push({ name: 'NotFound' });
            return;
        }
        try {
            // fetch the file metadata based on fileId
            const response = await axios.get(this.metadataUrl);
            this.file = {
                ID: response.data.id,
                Name: response.data.original_file_name,
                Extension: response.data.extension,
                URL: getAttachmentDownloadUrl(
                    `${window.location.origin}/api/media/files/${response.data.id}/${response.data.original_file_name}`
                ),
                size: response.data.size,
            } as AttachmentFile;
            // if file was already loaded, do not trigger download again
            if (this.wasLoaded) return;

            // wait a tick to ensure CoFile is rendered
            await this.$nextTick();
            // trigger the download
            this.$refs.coFileRef?.downloadAttachment();
            // mark as loaded
            this.wasLoaded = true;
        } catch (error) {
            // if error occurs (e.g., file not found), redirect to NotFound page
            console.error('Error fetching file metadata:', error);
            this.$router.push({ name: 'NotFound' });
        }
    },
};
